import { FC } from 'react';
import { Tabs } from 'antd';
import { hasSuperScripts } from 'modules/benefitsWellness/util';

import styles from './PlanCardBodyMobile.module.less';

const PlanCardBody: FC<any> = (props: any) => {
  const { mappings, plan } = props;

  const generateCardRows = () => {
    const rows = [] as any[];
    mappings.forEach((mapping: any, sectionIndex: any) => {
      const sectionNameDiv = (
        <div
          key={'pr-in-details-section-' + sectionIndex}
          className={
            mapping.sectionName
              ? styles.cardBodyTitleSection
              : styles.cardBodyNoTitleSection
          }
        ></div>
      );
      rows.push(sectionNameDiv);

      mapping.fields.forEach((key: any, index: any) => {
        if (index % 2) {
          const row = (
            <div
              key={'pr-in-details-row-' + sectionIndex + index}
              className={styles.cardBodyRowCaontainer}
            >
              <div className={`${styles.cardBodyRow} ${styles.cardBodyLight}`}>
                <div
                  className={styles.cardBodyValue}
                  title={key.inNetworkTitle}
                >
                  {key.inNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        } else {
          const row = (
            <div
              key={'pr-in-details-row-' + sectionIndex + index}
              className={`${styles.cardBodyRowCaontainer} ${
                index === 0 &&
                mapping.sectionName &&
                styles.cardBodyRowBorderContainer
              }`}
            >
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyDark
                }`}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.inNetworkTitle}
                >
                  {key.inNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        }
      });
      const seperator = (
        <div
          key={'pr-in-details-separator-' + sectionIndex}
          className={styles.cardBodyRowSeperator}
        ></div>
      );
      rows.push(seperator);
    });
    return rows;
  };

  const generateCardRowsOut = () => {
    const rows = [] as any[];
    mappings.forEach((mapping: any, sectionIndex: any) => {
      const sectionNameDiv = (
        <div
          key={'pr-out-details-section-' + sectionIndex}
          className={
            mapping.sectionName
              ? styles.cardBodyTitleSection
              : styles.cardBodyNoTitleSection
          }
        ></div>
      );
      rows.push(sectionNameDiv);

      mapping.fields.forEach((key: any, index: any) => {
        if (index % 2) {
          const row = (
            <div
              key={'pr-out-details-row-' + sectionIndex + index}
              className={styles.cardBodyRowCaontainer}
            >
              <div className={`${styles.cardBodyRow} ${styles.cardBodyLight}`}>
                <div
                  className={styles.cardBodyValue}
                  title={key.outOfNetworkTitle}
                >
                  {key.outOfNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        } else {
          const row = (
            <div
              key={'pr-out-details-row-' + sectionIndex + index}
              className={`${styles.cardBodyRowCaontainer} ${
                index === 0 &&
                mapping.sectionName &&
                styles.cardBodyRowBorderContainer
              }`}
            >
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyDark
                }`}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.outOfNetworkTitle}
                >
                  {key.outOfNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        }
      });
      const seperator = (
        <div
          key={'pr-out-details-separator-' + sectionIndex}
          className={styles.cardBodyRowSeperator}
        ></div>
      );
      rows.push(seperator);
    });
    return rows;
  };

  const cardRows = generateCardRows();
  const availableSuperScripts = hasSuperScripts([plan], 'InNetwork');
  hasSuperScripts([plan], 'OutOfNetwork').forEach((a) => {
    availableSuperScripts.add(a);
  });
  const cardRowsOut = generateCardRowsOut();
  const availableSuperScriptsOut = hasSuperScripts([plan], 'InNetwork');
  hasSuperScripts([plan], 'OutOfNetwork').forEach((a) => {
    availableSuperScriptsOut.add(a);
  });

  return (
    <div>
      <div>
        <Tabs defaultActiveKey="1" className={styles.TabView}>
          <Tabs.TabPane tab="In-Network" key="1" className={styles.TabOne}>
            <div key="In-Network" className={styles.planDetailCardBody}>
              {cardRows}
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Out-of-Network" key="2" className={styles.TabTwo}>
            <div key="Out-of-Network" className={styles.planDetailCardBody}>
              {cardRowsOut}
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default PlanCardBody;
